import React from "react";
import "./Eligibility_Section.css";

const Eligibility_Section = () => {
  return (
    <section className="eligibility-section">
      <div className="eligibility-container">
        {/* Left Content */}
        <div className="eligibility-left">
          <h2>
            Eligibility Criteria for Online MBA Program
            <span className="underline" />
          </h2>
          {/* <p>DY Patil Online MBA Program</p> */}
        </div>

        {/* Right Content */}
        <div className="eligibility-right">
          <h4>Learners are eligible to apply if they are :</h4>

          <ul>
            <li>
              Graduate in any discipline, from a recognized University.
              Minimum 50% for regular and 45% for category students
            </li>
            <li>
              Candidates who are in the final semester of the Bachelor
              Program are also eligible to apply.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Eligibility_Section;
